<template>
  <div class="page" id="page" v-cloak>
    <div class="h-nav" v-show="isTop == false">
      <div class="h-nav-item" @click="onClickLeft">
        <van-icon name="arrow-left" />
      </div>
    </div>

    <!-- 滑动后导航栏 -->
    <van-nav-bar v-show="isTop" :title="pageInfo.spec_title" :style="'background:' + pageInfo.bgColor +';'" fixed left-arrow @click-left="onClickLeft" @click-right="onClickRight"> </van-nav-bar>

    <!-- 顶部图片 -->
    <div class="top-img" @click="picGo(pageInfo.goods_id)"> <img :src="pageInfo.pic" alt=""></div>

    <div class="list" :style="'background:' + pageInfo.bgColor +';'">
      <van-list style="display: flex; flex-wrap:wrap;" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getProductList">
        <img-text-block :show-type="'column'" v-for="(item, index) in productList" :product="item" :key="index"></img-text-block>
      </van-list>
    </div>
  </div>
</template>

<script type="text/babel">
import imgTextBlock from "@/components/img-text-block/img-text-block.vue";
import sdk from "../../utils/wechart"; //引入sdk.js
export default {
  name: "activity",
  components: { imgTextBlock },
  props: {},
  data() {
    return {
      pageId: this.$route.query.mid,
      isTop: false,

      pageInfo: {
        goods_id: 0,
        goods_name: "",
        pic: "",
        remark: "",
        spec_title: "",
      },

      productList: [],

      pageNum: 1,
      pageSize: 20,
      loading: false,
      finished: true,
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getPageInfo();

    window.addEventListener("scroll", this.getScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
  methods: {
    getPageInfo() {
      let _this = this;
      let data = {
        special_id: this.pageId,
      };
      _this.$post("/api/special", data, data).then((res) => {
        // console.log(res.data);
        if (res && res.data.code == 0) {
          _this.pageInfo = res.data.data;
          document.title = res.data.data.spec_title;

          _this.pageNum = 1;
          _this.pageSize = 20;
          _this.loading = true;
          _this.finished = false;
          _this.getProductList();
          _this.shareDetail(res.data.data);
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    // 轮播图跳转商品
    picGo(even){
      if(even == 0 || even <= 0)return false;
      this.$router.push({ path: `/product-details/${even}` });
    },

    //监听滚动
    getScroll() {
      this.indexNumTop = $("#page").offset().top;
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop >= 100
      ) {
        // 设置滚动大于300时的执行内容
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
    // 返回上一页
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.replace({
          name: "index",
          query: {},
        });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
    onClickRight() {
      this.$toast("跳搜索");
      this.$router.push({
        name: "search",
        query: {},
      });
    },

    getProductList() {
      let _this = this;
      let data = {
        special_id: _this.pageId, // 分组ID
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/special_goods_list", data, data).then((res) => {
        // console.log(res.data);
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);
          // let lists = res.data.data;

          let lists = res.data.data.map((item, index) => {
            return Object.assign(item, { id: item.goods_id });
          });

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.productList = lists;
            } else {
              _this.productList = _this.productList.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            _this.finished = true; // 数据全部加载完成
          }
        } else {
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
    // 分享商品
    shareDetail(data) {
      let _this = this;
      // console.log(data.bgImg)
      let logo =
        "https://qiniu.zdyxjx.com/v3/pic/f30e30f2205a497f93351666655bc56c.png";
      let menuList = [
        "menuItem:share:qq", //分享到QQ
        "menuItem:share:weiboApp", // 分享到Weibo
        "menuItem:favorite", // 收藏
        "menuItem:share:QZone", // 分享到 QQ 空间
        "menuItem:copyUrl", // 复制链接
        "menuItem:openWithQQBrowser", // 在QQ浏览器中打开
        "menuItem:openWithSafari", // 在Safari中打开
        "menuItem:share:email", // 邮件
        "menuItem:readMode", // 阅读模式
        "menuItem:originPage", // 原网页
      ];
      var url = window.location.href.split("#")[0];

      let params = "?mid=" + _this.pageId;
      var obj = {
        title: data.spec_title || "百分百生活馆", //document.title, //分享标题
        desc: data.remark || "百分百生活馆", //分享内容
        linkurl:
          location.protocol + "//" + location.host + "/html/#/activity" + params,
        img: data.pic || logo, //分享内容显示的图片
      };
      sdk.getJSSDK(url, obj, menuList);
    },
  },
};
</script>

<style lang="scss" scoped>
.h-nav {
  position: fixed;
  top: 0;
  left: 0;
  height: 43px;
  width: 100%;
  padding: 0 15px;
  // background-color: #999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .h-nav-item {
    width: 30px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }
}
.page {
  height: 100%;
  width: 100%;

  .top-img {
    height: 250px;
    width: 100%;
    background-color: #eee;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px 50px;
  overflow: hidden;
  .divider {
    display: block;
    width: 100%;
    color: #999;
    line-height: 30px;
    text-align: center;
    font-size: 12px;
  }
}
</style>
